import { Container, Stack } from '@mui/material';
import { ReactNode } from 'react';

type AuthLayoutProps = {
  main?: ReactNode;
  footer?: ReactNode;
  /** Content width. Defaults to `sm`; narrower screens (e.g. Trackd's landing) use `xs`. */
  maxWidth?: 'xs' | 'sm' | 'md';
};

export const AuthLayout = ({ main, footer, maxWidth = 'sm' }: AuthLayoutProps) => {
  return (
    <Container maxWidth={maxWidth}>
      {/* 100dvh, not 100vh — on mobile browsers `vh` includes the collapsing address bar, which
          pushes the footer below the fold and lets the page scroll when it should not. */}
      <Stack sx={{ minHeight: '100dvh' }}>
        <Stack sx={{ flex: 1, gap: 1, alignItems: 'center', justifyContent: 'center' }}>
          {main}
        </Stack>
        {footer ? <Stack sx={{ alignItems: 'center', pb: 4 }}>{footer}</Stack> : null}
      </Stack>
    </Container>
  );
};
